'use client'

import s from './Toolbar.module.scss';
import {TToolbarProps} from "@/app/[locale]/common/components/Toolbar/types";

export const Toolbar = ({ applyInlineStyle }: TToolbarProps) => {
    return (
        <div className={s.toolbar}>
            <button type={'button'} onClick={() => applyInlineStyle("BOLD")}>Bold</button>
            <button type={'button'} onClick={() => applyInlineStyle("UNDERLINE")}>Underline</button>
            <button type={'button'} onClick={() => applyInlineStyle("STRIKETHROUGH")}>Strikethrough</button>
            <button type={'button'} onClick={() => applyInlineStyle("FONT_SIZE_16")}>Small size</button>
            <button type={'button'} onClick={() => applyInlineStyle("FONT_SIZE_18")}>Medium size</button>
            <button type={'button'} onClick={() => applyInlineStyle("FONT_SIZE_24")}>Large size</button>
        </div>
    );
};